export default __webpack_public_path__ + "static/media/0003.fbf23ac6.WAV";